import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

export const GetAllProperty = createAsyncThunk(
  "masters/property/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Masters.Property}?name=${filter?.name || ""}&sub_property_id=${
          filter?.sub_property_id || ""
        }&property_type_id=${filter?.property_type_id || ""}&page=${
          filter?.page || IDS.PAGE
        }&per_page=${filter?.per_page || IDS.PERPAGE}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const findAllWithSteps = createAsyncThunk(
  "masters/property/findallstepspagination",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Masters.findAllWithSteps}?name=${filter?.name || ""}&property_type_id=${filter?.property_type_id || ""}&page=${
          filter?.page || IDS.PAGE
        }&per_page=${filter?.per_page || IDS.PERPAGE}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const findAllDeletedProperty = createAsyncThunk(
  "masters/property/findalldeletedproperty",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Masters.findAllDeletedProperty}?name=${filter?.name || ""}&property_type_id=${filter?.property_type_id || ""}&page=${
          filter?.page || IDS.PAGE
        }&per_page=${filter?.per_page || IDS.PERPAGE}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetProperty = createAsyncThunk(
  "masters/property/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Masters.Property}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AddProperty = createAsyncThunk(
  "masters/property/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Masters.Property, data);
      return res;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const UpdateProperty = createAsyncThunk(
  "masters/property/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await PUT(`${APIS.Masters.Property}/${id}`, data);
      return res;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const UpdatePropertyStatus = createAsyncThunk(
  "masters/property/update-status",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await PUT(
        `${`${APIS.Masters.Property}/update-status`}/${id}`,
        data,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const DeleteProperty = createAsyncThunk(
  "masters/property/delete",
  async (id, { rejectWithValue }) => {
    try {
      await DELETE(`${APIS.Masters.Property}/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const StatusProperty = createAsyncThunk(
  "masters/property/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Masters.Property}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// New async thunk for fetching multi-select fields
export const GetProjectMultiSelectFields = createAsyncThunk(
  "masters/property/project-multi-select",
  async (projectId, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Masters.Property}/project/${projectId}/multi-select`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const AddStep1 = createAsyncThunk(
  "masters/property/step1",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Masters.AddStep1, data);
      return res;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
export const AddStep2 = createAsyncThunk(
  "masters/property/step2",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Masters.AddStep2, data);
      return res;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
export const AddStep3 = createAsyncThunk(
  "masters/property/step3",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Masters.AddStep3, data);
      return res;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
export const AddStep4 = createAsyncThunk(
  "masters/property/step4",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Masters.AddStep4, data);
      return res;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
export const AddStep5 = createAsyncThunk(
  "masters/property/step5",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Masters.AddStep5, data);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data); // ✅ ONLY send API response
    }
  },
);
export const AddStep6 = createAsyncThunk(
  "masters/property/step6",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Masters.AddStep6, data);
      return res;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
export const AddStep7 = createAsyncThunk(
  "masters/property/step7",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Masters.AddStep7, data);
      return res;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getStepsDetails = createAsyncThunk(
  "masters/property/steps",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Masters.getStepsDetails}/${id}`);
      console.log(res, "resresresresresres");
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const DeleteFlatVideo = createAsyncThunk(
  "masters/property/flat-delete",
  async (id, { rejectWithValue }) => {
    try {
      await DELETE(`${APIS.Masters.DeleteFlatVideo}/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const DeleteSingleImage = createAsyncThunk(
  "masters/property/deletesingleimage",
  async (id, { rejectWithValue }) => {
    try {
      await DELETE(`${APIS.Masters.DeleteSingleImage}/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "property",
  initialState: {
    data: [],
    dataforallsteps: [],
    datafordeletedproperty: [],
    stepdata: {},
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
    multiSelectFields: {
      amenities: [],
      property_parking: [],
      property_restriction: [],
      property_security: [],
      property_step_features: [],
    },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllProperty.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllProperty.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAllProperty.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(findAllWithSteps.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(findAllWithSteps.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.dataforallsteps = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(findAllWithSteps.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(findAllDeletedProperty.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(findAllDeletedProperty.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.datafordeletedproperty = action.payload?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(findAllDeletedProperty.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetProperty.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetProperty.fulfilled, (state) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetProperty.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AddProperty.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AddProperty.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data.unshift(action.payload.data);
      })
      .addCase(AddProperty.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(UpdateProperty.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(UpdateProperty.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        const index = state.data.findIndex(
          (property) => property.id === action.payload?.data?.id,
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(UpdateProperty.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(UpdatePropertyStatus.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(UpdatePropertyStatus.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        const index = state.data.findIndex(
          (property) => property.id === action.payload?.data?.id,
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(UpdatePropertyStatus.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(DeleteProperty.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(DeleteProperty.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = state.data.filter(
          (property) => property.id !== action.payload,
        );
      })
      .addCase(DeleteProperty.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(StatusProperty.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StatusProperty.fulfilled, (state) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(StatusProperty.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      // New cases for GetProjectMultiSelectFields
      .addCase(GetProjectMultiSelectFields.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetProjectMultiSelectFields.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.multiSelectFields = action.payload?.data || {
          amenities: [],
          property_parking: [],
          property_restriction: [],
          property_security: [],
          property_step_features: [],
        };
      })
      .addCase(GetProjectMultiSelectFields.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
        state.multiSelectFields = {
          amenities: [],
          property_parking: [],
          property_restriction: [],
          property_security: [],
          property_step_features: [],
        };
      })

      .addCase(AddStep1.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AddStep1.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data.unshift(action.payload.data);
      })
      .addCase(AddStep1.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AddStep2.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AddStep2.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data.unshift(action.payload.data);
      })
      .addCase(AddStep2.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AddStep3.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AddStep3.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data.unshift(action.payload.data);
      })
      .addCase(AddStep3.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(AddStep4.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AddStep4.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data.unshift(action.payload.data);
      })
      .addCase(AddStep4.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(AddStep5.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AddStep5.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data.unshift(action.payload.data);
      })
      .addCase(AddStep5.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(AddStep6.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AddStep6.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data.unshift(action.payload.data);
      })
      .addCase(AddStep6.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(AddStep7.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AddStep7.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data.unshift(action.payload.data);
      })
      .addCase(AddStep7.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(getStepsDetails.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(getStepsDetails.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.stepdata = action.payload?.message || {};
      })
      .addCase(getStepsDetails.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(DeleteFlatVideo.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(DeleteFlatVideo.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = state.data.filter(
          (property) => property.id !== action.payload,
        );
      })
      .addCase(DeleteFlatVideo.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(DeleteSingleImage.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(DeleteSingleImage.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = state.data.filter(
          (property) => property.id !== action.payload,
        );
      })
      .addCase(DeleteSingleImage.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export default Slice.reducer;
